import { render, staticRenderFns } from "./WelfareCentreNatureElderResidentsBedNumber.vue?vue&type=template&id=56ebcb62&scoped=true&"
import script from "./WelfareCentreNatureElderResidentsBedNumber.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreNatureElderResidentsBedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ebcb62",
  null
  
)

export default component.exports